// Custom React hook to fetch and provide target matrix lookup
console.log('useTargetMatrix loaded');
import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function useTargetMatrix() {
  const [matrix, setMatrix] = useState([]);
  const [serviceCodes, setServiceCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    Promise.all([
      axios.get(`${API_URL}/api/serviceCodes`),
      axios.get(`${API_URL}/api/service-code-targets`)
    ])
      .then(([codesRes, matrixRes]) => {
        setServiceCodes(codesRes.data);
        setMatrix(matrixRes.data);
      })
      .catch(() => setError('Failed to load target matrix'))
      .finally(() => setLoading(false));
  }, []);

  // Lookup function: returns the target value for a given size and service code
  // Updated lookup for array-of-arrays matrix
  function getTarget(size, serviceCodeId) {
    if (!size || !serviceCodeId || !matrix.length) return null;
    // Use only the first row for per-unit targets
    const baseRow = matrix[0];
    const perUnit = baseRow.targets?.[serviceCodeId];
    if (typeof perUnit !== 'number') return null;
    return Number(size) * perUnit;
  }

  return { matrix, serviceCodes, getTarget, loading, error };
}
